<template>
  <div class="detail-page">
    <!-- A部分：顶部导航 -->
    <van-nav-bar
        :title="detailData.IDNO || '单据详情'"
        left-arrow
        fixed
        @click-left="onClickLeft"
    />
    <div class="content-wrapper">
      <div class="content">
      <van-loading v-if="loading" type="spinner" size="40" vertical style="padding: 60px 0;">
        加载中...
      </van-loading>

      <template v-else>
        <!-- B部分：表头信息卡片 -->
        <div class="detail-card">
          <div class="card-title">销售单信息</div>

          <div class="info-list">
            <div class="info-item">
              <span class="info-label">客户名称</span>
              <span class="info-value">{{ detailData.CLNTNM}}</span>
            </div>
            <div class="info-item">
              <span class="info-label">订单合同号</span>
              <span class="info-value">{{ detailData.CLTORDNO}}</span>
            </div>
            <div class="info-item">
              <span class="info-label">订单日期</span>
              <span class="info-value">{{ detailData.ORDDTTM}}</span>
            </div>
            <div class="info-item">
              <span class="info-label">交货日期</span>
              <span class="info-value">{{ detailData.SHPDTTM}}</span>
            </div>

            <div class="info-item">
              <span class="info-label">收款账户</span>
              <span class="info-value">{{ detailData.ACTNM}}</span>
            </div>
            <div class="info-item">
              <span class="info-label">结算币种</span>
              <span class="info-value">{{ detailData.CRCYNM}}</span>
            </div>
            <div class="info-item">
              <span class="info-label">合计金额</span>
              <span class="info-value amount-text">{{ detailData.AMT}}</span>
            </div>
            <div class="info-item">
              <span class="info-label">应收金额</span>
              <span class="info-value amount-text">{{ detailData.ACTFEE}}</span>
            </div>
            <div class="info-item">
              <span class="info-label">含税</span>
              <span class="info-value">
                <van-tag :type="detailData.ISTAX === 'Y' ? 'success' : 'default'" size="medium">
                  {{ detailData.ISTAX === 'Y' ? '是' : '否' }}
                </van-tag>
              </span>
            </div>
            <div class="info-item">
              <span class="info-label">财务核算类型</span>
              <span class="info-value">{{ detailData.CHKTYNM}}</span>
            </div>
            <div class="info-item">
              <span class="info-label">整单优惠</span>
              <span class="info-value">{{ detailData.DISFEE || '0.00' }}</span>
            </div>
            <div class="info-item">
              <span class="info-label">业务员</span>
              <span class="info-value">{{ detailData.STAFFNM}}</span>
            </div>
          </div>
        </div>

        <!-- C部分：明细表格 -->
        <div class="table-card">
          <div class="card-title">销售明细</div>

          <div class="table-wrapper">
            <div class="table-scroll">
              <table class="detail-table">
                <thead>
                <tr>
                  <th>序号</th>
                  <th>订单类型</th>
                  <th>物品类别</th>
                  <th>产品编码</th>
                  <th>产品名称</th>
                  <th>产品类别</th>
                  <th>单位</th>
                  <th>客户需求数量</th>
                  <th>单价</th>
                  <th>税率</th>
                  <th>小计金额</th>
                  <th>生产预测数量</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(item, index) in detailOdrList" :key="item.LSTSEQ">
                  <td>{{ index + 1 }}</td>
                  <td>{{ item.ORDTYNM}}</td>
                  <td>{{ item.MATTY}}</td>
                  <td>{{ item.MATNO}}</td>
                  <td>{{ item.MATNM}}</td>
                  <td>{{ item.MATTYNM}}</td>
                  <td>{{ item.UNITNM}}</td>
                  <td>{{ item.QTY}}</td>
                  <td class="amount-cell">{{ item.PRC}}</td>
                  <td class="amount-cell">{{ item.RATENM}}</td>
                  <td class="amount-cell">{{ item.AMT}}</td>
                  <td>{{ item.PCQTY}}</td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>

          <!-- 合计信息 -->
          <div class="summary-section" v-if="detailOdrList.length > 0">
            <div class="summary-item">
              <span class="summary-label">客户需求数量合计：</span>
              <span class="summary-value">{{ totalOdrQty }}</span>
            </div>
            <div class="summary-item">
              <span class="summary-label">小计金额合计：</span>
              <span class="summary-amount">{{ totalOdrAmount }}</span>
            </div>
            <div class="summary-item">
              <span class="summary-label">生产预测数量合计：</span>
              <span class="summary-value">{{ totalOdrPcqty }}</span>
            </div>
          </div>
        </div>
        <div class="table-card">
          <div class="card-title">费用明细</div>

          <div class="table-wrapper">
            <div class="table-scroll">
              <table class="detail-table">
                <thead>
                <tr>
                  <th>序号</th>
                  <th>费用项目</th>
                  <th>单价</th>
                  <th>税率</th>
                  <th>数量</th>
                  <th>金额</th>
                  <th>科目名称</th>
                  <th>新增用户</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(item, index) in detailFeeList" :key="item.LSTSEQ">
                  <td>{{ index + 1 }}</td>
                  <td>{{ item.FEENM}}</td>
                  <td>{{ item.PRC}}</td>
                  <td>{{ item.RATE}}</td>
                  <td>{{ item.QTY}}</td>
                  <td>{{ item.AMT}}</td>
                  <td>{{ item.ACNM}}</td>
                  <td>{{ item.ADDUSER}}</td>
                </tr>
                </tbody>
              </table>
            </div>

          </div>

        </div>

        <!-- D部分：跟进备注 -->
        <div class="table-card">
          <div class="card-title">跟进备注</div>

          <div class="table-wrapper">
            <van-field
                v-model="v_rmk"
                rows="3"
                autosize
                type="textarea"
                placeholder="请输入备注"
                style="margin: 16px;"
            />
          </div>
        </div>
      </template>
    </div>
    </div>
    <!-- E部分：底部操作按钮 -->
    <div class="action-bar">
      <van-button
          type="danger"
          size="large"
          @click="handleReject"
          style="width: 48%;"
      >驳回
      </van-button>
      <van-button
          type="primary"
          size="large"
          @click="handleApprove"
          style="width: 48%;"
      >
        通过
      </van-button>
    </div>
  </div>
</template>

<script>
import { handleApprovalAction, backToList } from './approval'
import {Toast} from "vant-green";
export default {
  name: 'SalesDetail',
  data() {
    return {
      idseq: '',
      idno: '',
      v_usernm:this.$cookies.get('v_usernm'), //api 请求用户
      v_username: this.$cookies.get('v_telno'),
      v_corpid: this.$cookies.get('v_corpid'),
      detailData: {},
      v_cfmRow: {},
      detailList: [],
      detailOdrList: [],
      detailFeeList: [],
      showDialog: false,
      dialogTitle: '',
      approvalComment: '',
      currentAction: '', // 'approve' or 'reject'
      loading: false,
      v_rmk: ''
    }
  },
  computed: {
    // 计算总金额
    totalAmount() {
      return this.detailList.reduce((sum, item) => {
        return sum + parseFloat(item.AMT || 0)
      }, 0).toFixed(2)
    },
    // 销售明细合计
    totalOdrAmount() {
      return this.detailOdrList.reduce((sum, item) => {
        return sum + parseFloat(item.AMT || 0)
      }, 0).toFixed(2)
    },
    totalOdrQty() {
      return this.detailOdrList.reduce((sum, item) => {
        return sum + parseFloat(item.QTY || 0)
      }, 0).toFixed(2)
    },
    totalOdrPcqty() {
      return this.detailOdrList.reduce((sum, item) => {
        return sum + parseFloat(item.PCQTY || 0)
      }, 0).toFixed(2)
    },
    // 费用明细合计
    totalFeeAmount() {
      return this.detailFeeList.reduce((sum, item) => {
        return sum + parseFloat(item.AMT || 0)
      }, 0).toFixed(2)
    },
  },
  mounted() {
    // 优先使用 params 传递的完整对象
    if (this.$route.params.itemData) {
      const item = this.$route.params.itemData
      this.idseq = item.IDSEQ
      this.idno = item.IDNO
      this.v_cfmRow = item
    } else {
      // 兼容旧的 query 方式
      this.idseq = this.$route.query.idseq
      this.idno = this.$route.query.idno
    }

    if (this.idno) {
      this.getFinFee()
    }
  },
  methods: {
    // 获取销售单主表数据
    getFinFee() {
      this.loading = true
      this.$axios({
        method: 'post',
        url: 'xuper_auth/getBaseData',
        data: {
          p_key: "IDNO",
          p_value: this.idno,
          p_key2: "corpid",
          p_value2: this.v_corpid,
          p_table: "V_ord"
        }
      }).then(res => {
        if (res.code === '200' && res.result && res.result.length > 0) {
          const data = res.result[0]

          // 映射后端数据到页面显示字段
          this.detailData = {
            IDSEQ: data.IDSEQ,
            IDNO: data.IDNO,
            CLNTNM: data.CLNTNM || '',
            CLTORDNO: data.CLTORDNO || '',
            ORDDTTM: data.ORDDTTM || '',
            SHPDTTM: data.SHPDTTM || '',
            ACTNM: data.ACTNM || '',
            CRCYNM: data.CRCYNM || '',
            AMT: data.AMT || '0.00',
            ACTFEE: data.ACTFEE || '0.00',
            ISTAX: data.ISTAX || 'N',
            CHKTYNM: data.CHKTYNM || '',
            DISFEE: data.DISFEE || '0.00',
            STAFFNM: data.STAFFNM || '',
            TABNM: data.TABNM || 'ORD',
            IDTY: data.IDTY || '销售订单',
            TITLE: data.TITLE || '',
            ADDUSER: data.ADDUSER || ''
          }

          // 如果 v_cfmRow 为空，使用 detailData 填充
          if (!this.v_cfmRow || Object.keys(this.v_cfmRow).length === 0) {
            this.v_cfmRow = {
              IDSEQ: this.detailData.IDSEQ,
              IDNO: this.detailData.IDNO,
              TABNM: 'ORD',
              IDTY: '销售订单',
              TITLE: this.detailData.TITLE || `客户:${this.detailData.CLNTNM}`,
              ADDUSER: this.detailData.ADDUSER
            }
          }

          // 获取销售明细
          this.getFinOdrDetail(data.IDSEQ)
          // 获取费用明细
          this.getFinFeeDetail(data.IDSEQ)
        } else {
          this.$toast.fail('未找到销售单数据')
        }
      }).catch(err => {
        this.$toast.fail('加载数据失败')
      }).finally(() => {
        this.loading = false
      })
    },

    // 获取销售单明细数据
    getFinOdrDetail(IDSEQ) {
      this.$axios({
        method: 'post',
        url: 'xuper_auth/getBaseData',
        data: {
          p_key: "IDSEQ",
          p_value: IDSEQ,
          p_table: "V_orditm"
        }
      }).then(res => {
        if (res.code === '200' && res.result) {
          this.detailOdrList = res.result.map(item => ({
            LSTSEQ: item.LSTSEQ,
            ORDTYNM: item.ORDTYNM || '',
            MATTY: item.MATTY || '',
            MATNO: item.MATNO || '',
            MATNM: item.MATNM || '',
            MATTYNM: item.MATTYNM || '',
            UNITNM: item.UNITNM || '',
            QTY: item.QTY || '0',
            PRC: item.PRC || '0.00',
            RATENM: item.RATENM || '',
            AMT: item.AMT || '0.00',
            PCQTY: item.PCQTY || '0'
          }))
        }
      }).catch(err => {
        this.$toast.fail('加载销售明细失败')
      })
    },

    // 获取费用明细数据
    getFinFeeDetail(IDSEQ) {
      this.$axios({
        method: 'post',
        url: 'xuper_auth/getBaseData',
        data: {
          p_key: "IDSEQ",
          p_value: IDSEQ,
          p_table: "V_ordfee"
        }
      }).then(res => {
        if (res.code === '200' && res.result) {
          this.detailFeeList = res.result.map(item => ({
            LSTSEQ: item.LSTSEQ,
            FEENM: item.FEENM || '',
            PRC: item.PRC || '0.00',
            RATE: item.RATE || '0',
            QTY: item.QTY || '0',
            AMT: item.AMT || '0.00',
            ACNM: item.ACNM || '',
            ADDUSER: item.ADDUSER || ''
          }))
        }
      }).catch(err => {
        this.$toast.fail('加载费用明细失败')
      })
    },

    // 驳回审批
    handleReject(){
      handleApprovalAction(this, 'reject')
    },

    // 通过审批
    handleApprove() {
      handleApprovalAction(this, 'approve')
    },

    // 返回
    onClickLeft() {
      const from = this.$route.query.from
      if (from === 'index') {
        this.$router.push('/approval')
      } else {
        backToList(this, 'ORD')
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.detail-page {
  display: flex;
  flex-direction: column;
  height: 100%; /* 撑满父容器 */
  background: #f7f8fa;
}

.content-wrapper {
  flex: 1;
  overflow-y: auto;
  margin-top: 46px;
  margin-bottom: 72px;
  padding: 12px;
}


.detail-card,
.table-card,
.process-card {
  background: #fff;
  border-radius: 12px;
  padding: 16px;
  margin-bottom: 12px;

  .card-title {
    font-size: 16px;
    font-weight: 600;
    color: #323233;
    margin-bottom: 16px;
  }

  .info-list {
    .info-item {
      display: flex;
      align-items: flex-start;
      padding: 8px 0;
      border-bottom: 1px solid #EBEDF0;

      &:last-child {
        border-bottom: none;
      }

      .info-label {
        min-width: 90px;
        font-size: 14px;
        font-weight: 500;
        color: #646566;
        flex-shrink: 0;
        line-height: 22px;
      }

      .info-value {
        flex: 1;
        font-size: 14px;
        color: #323233;
        font-weight: 600;
        word-break: break-all;
        line-height: 22px;

        &.amount-text {
          color: #FF4000;
          font-weight: 600;
        }
      }
    }
  }


  .van-cell-group {
    margin: 0 -16px;

    ::v-deep .van-cell__value {
      word-break: break-all;
      white-space: normal;
      text-align: right;
    }

    ::v-deep .van-cell__title {
      word-break: break-all;
      white-space: normal;
    }
  }

  .required {
    color: #f44336;
    margin-right: 4px;
  }

  .amount-text {
    color: #f44336;
    font-weight: 600;
  }
}

.reason-section {
  margin-top: 16px;
  padding-top: 16px;
  border-top: 1px solid #f0f0f0;

  .section-title {
    font-size: 14px;
    font-weight: 500;
    color: #646566;
    margin-bottom: 12px;
  }

  .reason-content {
    font-size: 14px;
    color: #323233;
    line-height: 1.6;
    word-break: break-all;
    white-space: normal;
  }
}

.table-card {
  .table-wrapper {
    margin: 0 -16px;
  }

  .table-scroll {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }

  .detail-table {
    width: 100%;
    min-width: 800px;
    border-collapse: collapse;
    font-size: 13px;

    thead {
      background: #f7f8fa;

      th {
        padding: 12px 8px;
        text-align: left;
        font-weight: 600;
        color: #323233;
        border-bottom: 2px solid #ebedf0;
        white-space: nowrap;
      }
    }

    tbody {
      tr {
        border-bottom: 1px solid #f0f0f0;

        &:last-child {
          border-bottom: none;
        }

        &:hover {
          background: #f7f8fa;
        }
      }

      td {
        padding: 12px 8px;
        color: #646566;
        vertical-align: middle;
        word-break: break-all;
        white-space: normal;

        &.reason-cell {
          max-width: 200px;
        }

        &.amount-cell {
          color: #f44336;
          font-weight: 600;
          text-align: right;
          white-space: nowrap;
        }
      }
    }
  }

  .summary-section {
    background: #F7F8FA;
    border-radius: 8px;
    padding: 16px;
    margin-top: 16px;
    display: flex;
    flex-direction: column;
    gap: 12px;

    .summary-item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 8px 0;

      .summary-label {
        font-size: 14px;
        font-weight: 500;
        color: #646566;
        line-height: 22px;
      }

      .summary-value {
        font-size: 16px;
        font-weight: 600;
        color: #323233;
        line-height: 22px;
      }

      .summary-amount {
        font-size: 18px;
        font-weight: 700;
        color: #FF4000;
        line-height: 22px;
      }
    }
  }
}

.pay-status-pending {
  color: #ff9800;
  font-size: 12px;
}

.pay-status-paid {
  color: #4caf50;
  font-size: 12px;
}

.pay-status-partial {
  color: #2196f3;
  font-size: 12px;
}

.step-content {
  .step-user {
    font-size: 14px;
    color: #323233;
    margin-bottom: 4px;
  }

  .step-time {
    font-size: 12px;
    color: #969799;
  }

  .step-comment {
    font-size: 12px;
    color: #646566;
    margin-top: 4px;
  }
}

.action-bar {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: space-between;
  gap: 12px;
  padding: 12px;
  background: #fff;
  box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.06);
  z-index: 100;
}

</style>
